import type { PtCardSize, PtHealthStatus } from './types';

export const PT_HEALTH: Record<
  PtHealthStatus,
  { color: string; tint: string; label: string }
> = {
  ready: { color: 'var(--success)', tint: 'var(--success-tint)', label: 'Ready' },
  attention: { color: 'var(--gold)', tint: 'var(--gold-tint)', label: 'Needs prep' },
  critical: { color: 'var(--terracotta)', tint: 'var(--terracotta-tint)', label: 'Critical' },
};

export const PT_HUES = [
  '#5B8DEF',
  '#9B5CFF',
  '#3FB8A8',
  '#C0892E',
  '#2E7D54',
  '#C75A3F',
  '#5B7FB0',
];

export const PT_MIN_WIDTH: Record<PtCardSize, number> = {
  compact: 260,
  regular: 300,
  roomy: 340,
};

export const PT_FLAG_TONE: Record<string, { bg: string; fg: string }> = {
  gold: { bg: 'var(--gold-tint)', fg: '#9A6B1E' },
  warning: { bg: 'var(--terracotta-tint)', fg: 'var(--terracotta)' },
  info: { bg: 'var(--info-tint)', fg: 'var(--info)' },
  ai: { bg: 'var(--ai-tint)', fg: 'var(--ai-3)' },
};
